import { View } from "react-native";

import { Text } from "components/text_v2";
import { Spacer } from "components/spacer";
import { useMediaQuery } from "lib/media_query";

interface SpaceDetailProps {
  title: string;
  children: JSX.Element;
}

export function SpaceDetail({ title, children }: SpaceDetailProps) {
  const mq = useMediaQuery();
  const spacer = mq.deviceQuery.mobile ? 16 : 24;

  return (
    <View>
      <Text size="md" weight="semibold">
        {title}
      </Text>
      <Spacer size={spacer} />
      {children}
    </View>
  );
}
